import { observable, action, useStrict, runInAction, autorun, flow, set, toJS } from 'mobx';
import {
  isEmpty,
  isArray,
  cloneDeep,
  filter,
  merge,
  get,
  includes,
  has,
  pick,
  isUndefined,
  isNull
} from 'lodash';
import { Toast } from 'antd-mobile';
import Serv from './SicknessServ';

// 列表中的“其他”疾病，medicalId后台写死为32；
const otherSickMedicalId = 32;
class SicknessMod {
  // 病史基础数据
  @observable baseList = [];

  // inputItemList组件数据
  @observable inputListValueMap = {};

  // 会员病史
  @observable memberSickness = {};

  // 其他病史
  @observable otherSickness = '';

  // 其他病史id
  @observable otherSicknessId = '';

  /**
   * 修改状态
   */
  @action
  changeListValue(medicalId, value) {
    set(this.inputListValueMap, { [medicalId]: value });
  }

  /**
   * 基础数据：查询既往病史列表
   */
  queryBaseSickness = flow(function* () {
    try {
      const { data } = yield Serv.queryBaseSickness();
      if (Array.isArray(data)) {
        this.baseList = data;
      }
    } catch (error) {}
  });

  /**
   * 查询会员既往病史
   */
  querySickness = flow(function* () {
    try {
      const { data } = yield Serv.querySickness();
      if (Array.isArray(data)) {
        let newMap = {};
        this.baseList.forEach((_item) => {
          newMap[_item.id] = '';
        });
        this.inputListValueMap = newMap;
        data.forEach((_item) => {
          set(this.memberSickness, { [_item.medicalId]: _item });
          // 其他病史需要单独处理，不显示是否，而显示疾病名称
          if (_item.medicalId == otherSickMedicalId) {
            set(this.inputListValueMap, {
              [_item.medicalId]: _item.otherMedical ? '是' : '否'
            });
            this.otherSickness = _item.otherMedical;
            this.otherSicknessId = _item.id;
          } else {
            set(this.inputListValueMap, { [_item.medicalId]: _item.medicalStatus });
          }
        });
      }
    } catch (error) {}
  });

  /**
   * 修改既往病史
   */
  alterSickness = flow(function* (medicalId, status) {
    try {
      let params = {
        medicalId,
        medicalStatus: +status
      };
      if (medicalId in this.memberSickness) params.id = this.memberSickness[+medicalId].id;
      yield Serv.alterSickness([params]);
      // 修改成功，本地修改对应项的状态
      this.changeListValue(medicalId, status);
    } catch (error) {}
  });

  /**
   * 提交其他病史
   */
  saveOtherSickness = flow(function* (content) {
    try {
      const { otherSicknessId } = this;
      let params = {
        medicalId: otherSickMedicalId,
        medicalStatus: 1,
        otherMedical: content
      };
      if (otherSickMedicalId in this.memberSickness)
        params.id = this.memberSickness[+otherSickMedicalId].id;
      yield Serv.alterSickness([params]);
      // 提交成功，返回
      Toast.success('提交成功！', 1, () => {
        window.app.router.goBack();
      });
    } catch (error) {}
  });
}
const sicknessMod = new SicknessMod();
export default sicknessMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Sickness/SicknessMod.js